export default __webpack_public_path__ + "static/media/scale.e6927d54.png";